import { Stack, Tab, Tabs } from "@mui/material";
import type { FC } from "react";
import type { Segment } from "../../../../types";
import type { EditSegmentModalProps } from "../types";
import { SegmentHistory } from "./segment-history";
import { SegmentRecipientsDataGrid } from "./segment-recipients-data-grid";
import { SegmentRelatedMomentsDataGrid } from "./segment-related-moments-data-grid";

export type EditModalTab = "DETAILS" | "RELATED_MOMENTS" | "RECIPIENTS" | "HISTORY";

export const TabbedEditSegmentModal: FC<
  Pick<EditSegmentModalProps, "disabled"> & {
    segment: Segment;
    tab: EditModalTab;
    setTab: (tab: EditModalTab) => void;
    children: React.ReactNode;
    include_recipients_tab?: boolean;
  }
> = ({ segment, tab, setTab, children, include_recipients_tab = true }) => {
  return (
    <Stack direction="column" spacing={4}>
      <Tabs
        indicatorColor="primary"
        scrollButtons="auto"
        textColor="primary"
        value={tab}
        variant="scrollable"
        sx={{ mt: 3 }}
      >
        <Tab
          key="DETAILS"
          label="Details"
          value="DETAILS"
          onClick={() => setTab("DETAILS")}
          data-analytics-id="segment_details_tab"
        />
        <Tab
          key="RELATED_MOMENTS"
          label="Related Communications"
          value="RELATED_MOMENTS"
          onClick={() => setTab("RELATED_MOMENTS")}
          data-analytics-id="segment_related_moments_tab"
        />
        {include_recipients_tab && (
          <Tab
            key="RECIPIENTS"
            label="Recipients"
            value="RECIPIENTS"
            onClick={() => setTab("RECIPIENTS")}
            data-analytics-id="segment_recipients_tab"
          />
        )}
        {segment.segment_json && (
          <Tab
            key="HISTORY"
            label="History"
            value="HISTORY"
            onClick={() => setTab("HISTORY")}
            data-analytics-id="segment_history_tab"
          />
        )}
      </Tabs>
      {tab === "DETAILS" && children}
      {tab === "RELATED_MOMENTS" && <SegmentRelatedMomentsDataGrid segmentId={segment.id} />}
      {tab === "RECIPIENTS" && include_recipients_tab && <SegmentRecipientsDataGrid />}
      {tab === "HISTORY" && segment.segment_json && <SegmentHistory segmentId={segment.id} />}
    </Stack>
  );
};
